cv.CustomFieldGroupsView = Marionette.CompositeView.extend({
  template: cv.Templates["global/custom_fields_form/custom_field_groups"],
  childViewContainer: ".custom-field-groups",
  childView: cv.CustomFieldGroupsRowView,
  emptyView: cv.CustomFieldGroupsRowEmptyView,

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
      suppress_notifications: true,
    },
  ],

  events: {
    "update-group-sort": "updateSort",
    "click .add-normal": "addNormalGroup",
    "click .add-repeating": "addRepeatingGroup",
    "click .add-row a": "addRow",
  },

  childEvents: {
    show: function () {},
    render: function () {},
  },

  collectionEvents: {
    reset: "collectionReset",
  },

  childViewOptions: function (model, index) {
    // do some calculations based on the model
    // if values is an array we are a nested group and we should pass the right one
    if (_.isArray(this.options.values)) {
      if (!_.isUndefined(this.options.values[index])) {
        return {
          edit_mode: this.options.edit_mode,
          values: this.options.values[index],
          nested: this.options.nested,
          is_donation_form: this.options.is_donation_form,
        };
      } else {
        return {
          edit_mode: this.options.edit_mode,
          values: {},
          nested: this.options.nested,
          is_donation_form: this.options.is_donation_form,
        };
      }
    } else {
      return {
        edit_mode: this.options.edit_mode,
        values: this.options.values,
        nested: this.options.nested,
        is_donation_form: this.options.is_donation_form,
      };
    }
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // Set some defaults
    if (_.isUndefined(this.options.nested)) {
      this.options.nested = false;
    }

    // Listeners to show/hide remove row button
    this.listenTo(
      this.collection,
      "remove",
      function () {
        if (this.collection.length == 1) {
          this.$(".remove-row").hide();
        }
      },
      this
    );
    this.listenTo(
      this.collection,
      "add",
      function () {
        this.$(".remove-row").show();
      },
      this
    );

    // If we are not nested, then we link this to the root groups view, otherwise the nested one will link automatically to the root view
    if (this.options.nested == false) {
      this.listenTo(
        vent,
        "custom_field:unlink_group",
        function (view) {
          this.trigger("form:unlink", view);
        },
        this
      );

      // View modes
      this.listenTo(
        vent,
        "custom_field:edit_form",
        function () {
          this.$(".add-group").show();
        },
        this
      );
      this.listenTo(
        vent,
        "custom_field:preview_form",
        function () {
          this.$(".add-group").hide();
        },
        this
      );
    }

    console.log("CustomFieldGroupsView initialized");
  },

  templateHelpers: function () {
    return {
      is_nested: this.options.nested,
      is_edit_mode: this.options.edit_mode,
    };
  },

  updateSort: function (event, model, position) {
    this.collection.remove(model, { silent: true });

    this.collection.each(function (model, index) {
      var ordinal = index;
      if (index >= position) {
        ordinal += 1;
      }
      model.set("ordinal", ordinal);
    });

    model.set("ordinal", position);
    this.collection.add(model, { at: position, silent: true });

    // to update ordinals on server:
    var ids = this.collection.pluck("id");
    console.log("post ids to server: " + ids.join(", "));
  },

  addRow: function (e) {
    e.preventDefault();

    if (this.options.edit_mode == true) {
      // Pop up the modal
      var view = new cv.AlertView({
        title: "Preview Mode",
        message:
          "Adding a row is disabled in preview mode.  This is just to show you how it looks.",
      });
      vent.trigger("modal:show", view);

      return false;
    }

    this.collection.add(this.options.empty_row);
  },

  addNormalGroup: function (e) {
    e.preventDefault();

    var view = new cv.EditCustomFieldView({
      add_field: true,
      model: new cv.CustomField(),
    });
    vent.trigger("modal:show", view);

    this.listenTo(
      view,
      "form:saved",
      function (view) {
        var fields = [];
        fields.push(view.model.toJSON());
        var new_group = new cv.CustomFieldGroup({
          id: null,
          label: " ",
          type: "normal",
          fields: fields,
        });
        this.collection.add(new_group);

        vent.trigger("modal:hide");
      },
      this
    );
  },

  addRepeatingGroup: function (e) {
    e.preventDefault();

    var view = new cv.EditCustomFieldView({
      add_repeating: true,
      model: new cv.CustomField(),
    });
    vent.trigger("modal:show", view);

    this.listenTo(
      view,
      "form:saved",
      function (view) {
        var fields = [];
        fields.push(view.model.toJSON());
        var new_group = new cv.CustomFieldGroup({
          id: null,
          label: "Repeating Group",
          type: "repeating",
          fields: fields,
        });
        this.collection.add(new_group);

        vent.trigger("modal:hide");
      },
      this
    );
  },

  collectionReset: function () {
    this.$(".custom-field-groups").html("");

    if (this.options.edit_mode == true) {
      vent.trigger("custom_field:edit_form");
    }

    // Show the container if we have it specified
    if (
      this.options.nested == false &&
      !_.isNull(this.options.container) &&
      this.collection.length > 0
    ) {
      this.options.container.show();
    }
  },

  attachHtml: function (collectionView, childView, index) {
    collectionView.trigger("form:link", childView);

    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    } else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)) {
        collectionView._insertAfter(childView);
      }
    }
  },

  isEmpty: function (collection) {
    if (collection.length == 0) {
      if (this.options.nested == false && !_.isNull(this.options.container)) {
        this.options.container.hide();
      }
      return true;
    }
    return false;
  },

  onBeforeShow: function () {
    // If we are a root group, the grab this jamz
    if (this.options.nested == false) {
      if (this.collection.length == 0) {
        $.ajax({
          url: cv.campaign.url() + "/custom_fields?type=" + this.options.type,
          data: {},
          dataType: "json",
          type: "GET",
          success: _.bind(function (data) {
            this.collection.reset(data);
          }, this),
        });
      }
    }
  },

  onRender: function () {
    if (this.options.edit_mode == true) {
      this.$(".custom-field-groups").sortable({
        handle: ".custom-field-group-heading",
        update: _.bind(function (event, ui) {
          ui.item.trigger("dropGroup", ui.item.index());
        }, this),
      });
    }

    if (this.collection.length == 1) {
      this.$(".remove-row").hide();
    }
  },

  onDestroy: function () {
    if (this.options.edit_mode == true && this.$(".custom-field-groups").hasClass("ui-sortable")) {
      this.$(".custom-field-groups").sortable("destroy");
    }

    vent.trigger("custom_field:unlink_groups", this);
  },
});
